import axios from "axios"
import { Notification } from "element-ui"
import config from "./env.js"

// 供货商门户独立请求封装:与管理后台根目录request.js同构(baseURL/useref头机制),
// 区别:令牌取自sessionStorage的supplierToken(供货商登录返回的userAes),
// 与管理后台localStorage的Qy_token互不影响,互不越权(后端按令牌d=4识别供货商)
var supplierRequest = axios.create({
  baseURL: config.baseURL
})

// 请求拦截器:带供货商useref令牌(登录接口本身无令牌,允许为空)
supplierRequest.interceptors.request.use(
  (cfg) => {
    const token = sessionStorage.getItem("supplierToken")
    if (token) {
      cfg.headers.common["useref"] = token
    }
    return cfg
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器:HTTP正常时返回res.data(含status/result/msg/data/total);
// 与管理后台拦截器"失败弹窗并返回undefined"不同,这里业务失败也原样返回,
// 由页面按status判断——登录失效时页面可感知并清token跳回供货商登录页
supplierRequest.interceptors.response.use(
  (res) => {
    return res.data
  },
  (error) => {
    Notification({
      title: "警告",
      message: "网络异常,请稍后重试",
      type: "warning"
    })
    return Promise.reject(error)
  }
)

export default supplierRequest
